import { WelcomeBannerProps } from '@/typings/components';
import type { EditableComponentProps } from '@adobe/aem-react-editable-components';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service';

const resourceType = `${EnvVarsService.getVar('VITE_APP_ID')}/components/welcomebanner`;

const config = {
	emptyLabel: 'WelcomeBanner',
	isEmpty: (props: EditableComponentProps & WelcomeBannerProps) => {
		if (!props) return true;

		const { cta, text } = props;

		return !cta && !text;
	},
	resourceType,
};

export default config;
